export default [
  {
    key: 'nilai-kasek',
    program: 'Seleksi Kandidat <strong>Kepala Sekolah</strong>',
    subheading: 'Seleksi Kandidat (Kepala Sekolah)',
    submenu: false,
    menu: [
      {
        icon: 'mdi-account-check-outline',
        title: 'Daftar Riwayat Hidup (CV)',
        subtitle: 'Kepala Sekolah',
        desc: 'Evaluasi dan Verifikasi Daftar Riwayat Hidup (CV) Peserta Sekolah Penggerak',
        color: 'blue',
        deepColor: 'darken-2',
        akses: 'psp-peserta-berkas.index',
        link: 'verval-cv-kasek',
        to: { name: 'verval-cv-kasek' },
      },
      {
        icon: 'mdi-account-check-outline',
        title: 'Pengecekan Prasyarat',
        desc: 'Pengecekan Prasyarat Pendaftaran Calon Sekolah Penggerak',
        color: 'success',
        deepColor: 'darken-2',
        akses: 'psp-peserta-profil.prasyarat',
        link: 'cek-prasyarat',
        to: { name: 'cek-prasyarat' },
      },
      {
        icon: 'mdi-file',
        title: 'CV KS Cadangan',
        subtitle: 'Kepala Sekolah',
        desc: 'Verifikasi Daftar Riwayat Hidup (CV) Peserta Kepala Sekolah Cadangan',
        color: 'blue',
        deepColor: 'darken-2',
        akses: 'psp-peserta-berkas-izin.index',
        link: 'verval-izin-ks',
        to: { name: 'verval-izin-ks' },
      },
      {
        icon: 'mdi-comment-edit',
        title: `Esai Kepala Sekolah`,
        subtitle: '14 - 27 Maret 2022',
        desc: 'Penilaian Esai Kandidat Kepala Sekolah <br/>' + `14 - 27 Maret 2022`,
        color: 'orange',
        deepColor: 'darken-2',
        akses: 'psp-peserta-esai.index',
        link: 'penilaian-esai',
        to: { name: 'penilaian-esai' },
      },
      {
        icon: 'mdi-teach',
        title: `Simulasi & Wawancara`,
        subtitle: '',
        desc: ['Penilaian dan jadwal Simulasi Mengajar dan Wawancara', '9 April - 10 Juni 2022'].join('<br/>'),
        color: 'teal',
        deepColor: 'lighten-1',
        akses: 'psp-peserta-simulasi-ajar.index',
        link: 'penilaian-microteaching-kasek',
        to: { name: 'penilaian-microteaching-kasek' },
      },
      {
        icon: 'mdi-clipboard-plus-outline',
        title: `Verval Surat Keterangan Sehat`,
        subtitle: 'Kepala Sekolah',
        desc: 'Verifikasi dan Validasi Surat Keterangan Sehat Calon Kepala Sekolah',
        color: 'green',
        deepColor: 'lighten-1',
        akses: 'psp-peserta-berkas-sehat.index',
        link: 'verval-sehat-ks',
        to: { name: 'verval-sehat-ks' },
      },
      {
        icon: 'mdi-order-bool-descending',
        title: 'Borang Peringkat',
        subtitle: 'Sekolah Penggerak',
        desc: 'Pengaturan Borang Peringkat Peserta Program Sekolah Penggerak',
        color: 'green',
        deepColor: '',
        akses: 'psp-peringkat-dinas.index',
        link: 'peringkat',
        to: { name: 'peringkat' },
      },
      {
        icon: 'mdi-format-list-checks',
        title: 'Borang Peringkat',
        subtitle: 'Sekolah Penggerak',
        desc: 'Pengaturan Borang Peringkat Peserta Program Sekolah Penggerak',
        color: 'green',
        deepColor: '',
        akses: 'psp-peringkat-verval.index',
        link: 'peringkat-verval',
        to: { name: 'peringkat-verval' },
      },
      {
        icon: 'mdi-format-list-checkbox',
        title: 'Daftar Peserta PSP',
        subtitle: 'Sekolah Penggerak',
        desc: 'Daftar Seluruh Peserta Program Sekolah Penggerak',
        color: 'pink',
        deepColor: '',
        akses: 'psp-peserta-lulus.index',
        link: 'dikualifikasi-ks',
        to: { name: 'diskualifikasi-ks' },
      },
      {
        icon: 'mdi-account-group',
        title: 'Daftar Sekolah Penggerak',
        subtitle: '',
        desc: 'Daftar Seluruh Peserta Sekolah Penggerak',
        color: 'pink',
        deepColor: '',
        akses: 'psp-peserta-pelaksana.index',
        link: 'peserta-pelaksana',
        to: { name: 'peserta-pelaksana' },
      },
    ],
  },
  {
    key: 'nilai-instruktur',
    program: 'Seleksi Kandidat <strong>Fasilitator</strong>',
    subheading: 'Seleksi Kandidat (Fasilitator)',
    submenu: false,
    menu: [
      {
        icon: 'mdi-account-check-outline',
        title: 'Daftar Riwayat Hidup (CV)',
        subtitle: 'Fasilitator',
        desc: 'Evaluasi dan Verifikasi Daftar Riwayat Hidup (CV) Peserta Sekolah Penggerak',
        color: 'blue',
        deepColor: 'darken-4',
        akses: 'psp-pelatih-ahli-berkas.index',
        link: 'verval-cv-pa',
        to: { name: 'verval-cv-pa' },
      },
      {
        icon: 'mdi-comment-edit',
        title: `Esai Fasilitator`,
        subtitle: '',
        desc: '',
        color: 'orange',
        deepColor: 'darken-4',
        akses: 'psp-pelatih-ahli-esai.index',
        link: 'penilaian-esai-pa',
        to: { name: 'penilaian-esai-pa' },
      },
      {
        icon: 'mdi-teach',
        title: `Simulasi & Wawancara`,
        subtitle: '',
        desc: ['Penilaian dan jadwal Simulasi Melatih dan Wawancara fasilitator', '04 s/d 14 Juli 2022'].join('<br/>'),
        color: 'red',
        deepColor: 'lighten-1',
        akses: 'psp-pelatih-ahli-simulasi-ajar.index',
        link: 'penilaian-microteaching-instruktur',
        to: { name: 'penilaian-microteaching-instruktur' },
      },
      {
        icon: 'mdi-clipboard-plus-outline',
        title: `Verval Surat Keterangan Sehat`,
        subtitle: 'Fasilitator',
        desc: 'Verifikasi dan Validasi Surat Keterangan Sehat Calon Fasilitator',
        color: 'green',
        deepColor: 'lighten-1',
        akses: 'psp-pelatih-ahli-berkas-sehat.index',
        link: 'verval-sehat-pa',
        to: { name: 'verval-sehat-pa' },
      },
      {
        icon: 'mdi-clipboard-check',
        title: `Verval Surat Pernyataan Komitmen`,
        subtitle: 'Fasilitator',
        desc: 'Verifikasi dan Validasi Surat Pernyataan Komitmen Calon Fasilitator',
        color: 'brown',
        deepColor: 'lighten-1',
        akses: 'psp-pelatih-ahli-berkas-mundur.index',
        link: 'verval-mundur-pa',
        to: { name: 'verval-mundur-pa' },
      },
      {
        icon: 'mdi-format-list-checkbox',
        title: 'Daftar Fasilitator PSP',
        subtitle: 'Sekolah Penggerak',
        desc: 'Daftar Seluruh Fasilitator Program Sekolah Penggerak',
        color: 'pink',
        deepColor: '',
        akses: 'psp-pelatih-ahli-lulus.index',
        link: 'dikualifikasi-fasilitator',
        to: { name: 'diskualifikasi-fasilitator' },
      },
      {
        icon: 'mdi-account-check-outline',
        title: 'Verval Perubahan Profil FSP',
        desc: 'Verval untuk pembaruan data yang telah dilakukan oleh FSP',
        color: 'blue',
        deepColor: 'darken-4',
        akses: 'psp-pelatih-ahli-biodata-edit.index',
        link: 'verval-biodata-edit-fsp',
        to: { name: 'verval-biodata-edit-fsp' },
      },
      {
        icon: 'mdi-account-check-outline',
        title: 'Verval Profil FSP',
        desc: 'Perbaikan Data Profil dan Tambahan Informasi untuk Fasilitator yang dinyatakan lolos seleksi',
        color: 'green',
        deepColor: 'darken-4',
        akses: 'psp-pelatih-ahli-biodata.index',
        link: 'verval-fsp',
        to: { name: 'verval-fsp' },
      },
      {
        icon: 'mdi-file-plus',
        title: 'Lihat Berkas Tambahan FSP',
        desc: 'Berkas tambahan yang telah diunggah FSP',
        color: 'pink',
        deepColor: 'darken-1',
        akses: 'psp-pelatih-ahli-berkas-bersedia.index',
        link: 'verval-berkas-tambahan-fsp',
        to: { name: 'verval-berkas-tambahan-fsp' },
      },
    ],
  },
  {
    key: 'pmo',
    program: 'Pendampingan  <strong>FSP</strong>',
    subheading: 'Pendampingan FSP',
    submenu: false,
    menu: [
      {
        key: 'dkp',
        icon: 'mdi-google-classroom',
        title: 'Kelola Pendampingan oleh IN',
        subtitle: 'Instruktur ad Interim',
        desc: 'Kelola Kelompok Pendampingan Komite Pembelajar',
        color: 'indigo',
        deepColor: '',
        akses: 'psp-peserta-kp.index',
        link: 'diklat-pendampingan',
        to: { name: 'diklat-pendampingan' },
      },
      {
        key: 'pendampingan',
        icon: 'mdi-google-classroom',
        title: 'Pendampingan oleh Instruktur/PA',
        subtitle: 'ad Interim',
        desc: 'Kelola Pendampingan Komite Pembelajar',
        color: 'pink',
        deepColor: '',
        akses: 'psp-peserta-pendampingan.index',
        link: 'pendampingan',
        to: { name: 'pendampingan' },
      },
      {
        icon: 'mdi-account-group',
        title: 'Kelola Koordinator Fasilitator',
        desc: 'Pengelolaan data Koordinator bagi para Fasilitator',
        color: 'green',
        deepColor: 'accent-3',
        akses: 'psp-pelatih-ahli-koordinator.index',
        link: 'koordinator-pa',
        to: { name: 'koordinator-pa' },
      },
      {
        key: 'dkp-pa',
        icon: 'mdi-google-classroom',
        title: 'Laporan PMO & Pendampingan Individu',
        desc: 'Kelola Kelompok Pendampingan oleh Fasilitator',
        color: 'teal',
        deepColor: '',
        akses: 'psp-peserta-kp-pa.index',
        link: 'diklat-pendampingan-pa',
        to: { name: 'diklat-pendampingan-pa' },
      },
      {
        icon: 'mdi-account-group',
        title: 'Laporan Pendampingan Kelompok',
        subtitle: 'Sekolah Penggerak',
        desc: 'Kelola Laporan Pendampingan Kelompok',
        color: 'orange',
        deepColor: '',
        akses: 'psp-peserta-kp-lokakarya.index',
        link: 'diklat-lokakarya',
        to: { name: 'diklat-lokakarya' },
      },
      {
        icon: 'mdi-account-group',
        title: 'Laporan Lingkup Satuan Pendidikan',
        subtitle: 'Sekolah Penggerak',
        desc: 'Monitoring Laporan Lingkup Satuan Pendidikan',
        color: 'blue',
        deepColor: '',
        akses: 'psp-peserta-pendampingan-lingkup.index',
        link: 'laporan-lingkup-pendidikan',
        to: { name: 'laporan-lingkup-pendidikan' },
      },
      {
        icon: 'mdi-file',
        title: 'Laporan Kegiatan Koordinator',
        subtitle: 'Sekolah Penggerak Tahun 1',
        desc: 'Rangkuman laporan oleh koordinator PA (Fasilitator) sesuai dengan Kegiatan yang telah Berlangsung.',
        color: 'orange',
        deepColor: '',
        akses: 'psp-pelatih-ahli-koordinator-laporan.index',
        link: 'koordinator-laporan-pa',
        to: { name: 'koordinator-laporan-pa' },
      },
      {
        icon: 'mdi-file',
        title: 'Laporan Kegiatan Koordinator',
        subtitle: 'Sekolah Penggerak',
        desc: 'Rangkuman laporan oleh koordinator PA (Fasilitator) sesuai dengan Kegiatan yang telah Berlangsung.',
        color: 'red',
        deepColor: '',
        akses: 'psp-pelatih-ahli-koordinator-pa-laporan.index',
        link: 'laporan-koordinator-pa',
        to: { name: 'laporan-koordinator-pa' },
      },
      {
        icon: 'mdi-file-document-multiple',
        title: 'Lihat Laporan Kegiatan Koordinator',
        subtitle: 'Sekolah Penggerak',
        desc: 'Lihat rangkuman laporan oleh koordinator PA (Fasilitator).',
        color: 'green',
        deepColor: '',
        akses: 'psp-pelatih-ahli-koordinator-pa-laporan.koordinator',
        link: 'daftar-laporan-koordinator-pa',
        to: { name: 'daftar-laporan-koordinator-pa' },
      },
      {
        icon: 'mdi-format-list-checks',
        title: 'Evaluasi Kinerja',
        desc:
          'Modul evkin ini digunakan untuk menilai terhadap kinerja yang telah dilakukan oleh setiap peran dalam Program Sekolah Penggerak terhadap peran lainnya.',
        color: 'indigo darken-1',
        deepColor: '',
        akses: 'psp-peserta-kinerja.index',
        link: 'kinerja',
        to: { name: 'kinerja' },
      },
      {
        icon: 'mdi-file-document-multiple',
        title: 'Modul Perangkat Pendampingan',
        subtitle: 'Sekolah Penggerak',
        desc: 'Modul Perangkatan Pendampingan untuk FSP.',
        color: 'deep-purple',
        deepColor: 'darken-1',
        akses: false,
        link: 'modul-pendampingan',
        to: { name: 'modul-pendampingan' },
      },
      {
        icon: 'mdi-calendar',
        title: 'Penjadwalan Kegiatan BBGP / BGP',
        subtitle: 'Sekolah Penggerak',
        desc: 'Laporan Penjadwalan Kegiatan oleh BBGP / BGP',
        color: 'indigo',
        deepColor: '',
        akses: 'psp-peserta-pendampingan-lokakarya-dinas.index',
        link: 'laporan-lokakarya-dinas',
        to: { name: 'laporan-lokakarya-dinas' },
      },
      {
        icon: 'mdi-file-clock',
        title: 'Umpan Balik Kegiatan Pendampingan',
        subtitle: '',
        desc: 'Rekap Laporan umpan balik pada Kegiatan Pendampingan Kelompok',
        color: 'orange',
        deepColor: 'darken-1',
        akses: 'psp-peserta-kp-lokakarya-feedback.index',
        key: 'rekap-feedback',
        disable: false,
        to: { name: 'rekap-feedback' },
      },
      {
        icon: 'mdi-file-clock',
        title: 'Rekapan Lembar Umpan Balik Kegiatan Pendampingan',
        subtitle: '',
        desc: 'Rekap Laporan lembar umpan balik pada Kegiatan Pendampingan Kelompok',
        color: 'red',
        deepColor: 'darken-1',
        akses: 'psp-peserta-kp-lokakarya-rekap.index',
        key: 'rekap-lokakarya',
        disable: false,
        to: { name: 'rekap-lokakarya' },
      },
      {
        icon: 'mdi-file-clock-outline',
        title: 'Ajuan Bantuan Pendampingan PA',
        subtitle: 'Sekolah Penggerak',
        desc:
          'Laporan Ajuan Bantuan Pendampingan Komite Pembelajaran yang dikirimkan oleh Fasilitator untuk segera ditindaklanjuti',
        color: 'pink',
        deepColor: '',
        akses: 'psp-peserta-pendampingan-pa.index',
        link: 'diklat-pelaporan',
        to: { name: 'diklat-pelaporan' },
      },
    ],
  },
  {
    key: 'pelatihan',
    program: 'Pelatihan <strong>Pengimbasan</strong>',
    subheading: 'Pelatihan Pengimbasan',
    submenu: false,
    menu: [
      {
        icon: 'mdi-book-open-page-variant',
        title: 'Kelola Ajuan Peserta',
        subtitle: 'Pelatihan Pengimbasan',
        desc: 'Pengelolaan Peserta Pelatihan Pengimbasan',
        color: 'blue',
        deepColor: 'darken-1',
        akses: 'psp-pelatihan-imbas.index',
        link: 'pengimbasan-ajuan',
        to: { name: 'pengimbasan-ajuan' },
      },
      {
        icon: 'mdi-account-multiple',
        title: 'Pengkelasan Pelatihan Pengimbasan',
        subtitle: 'Pelatihan Pengimbasan',
        desc: 'Pengelolaan Peserta Pelatihan Pengimbasan',
        color: 'green',
        deepColor: 'darken-1',
        akses: 'psp-pelatihan-imbas-kelas.index',
        link: 'pengimbasan-kelas',
        to: { name: 'pengimbasan-kelas' },
      },
      {
        icon: 'mdi-marker',
        title: 'Penilaian Peserta Pengimbasan',
        subtitle: 'Modul untuk menilai peserta pengimbasan',
        desc: 'Penilaian Peserta Pelatihan Pengimbasan',
        color: 'blue',
        deepColor: 'darken-1',
        akses: 'psp-pelatihan-imbas-nilai.save',
        link: 'pengimbasan-nilai',
        to: { name: 'pengimbasan-nilai' },
      },
      {
        link: 'modul-pengimbasan',
        icon: 'mdi-file-document-multiple',
        title: 'Modul dan Materi Pengimbasan',
        desc: 'Daftar Modul dan Materi Pengimbasan',
        color: 'purple darken-1',
        deepColor: '',
        akses: false,
      },
    ],
  },
  {
    key: 'iht',
    program: 'Diklat  <strong>IHT</strong>',
    subheading: 'Diklat IHT',
    submenu: false,
    menu: [
      {
        icon: 'mdi-file-clock-outline',
        title: 'Laporan UPT Sekolah',
        subtitle: 'Sekolah Penggerak',
        desc: 'Penilaian Laporan Pelaksanaan IHT di lokasi',
        color: 'red',
        deepColor: 'darken-2',
        akses: 'psp-monev-dinas.index',
        link: 'diklat-upt',
        to: { name: 'diklat-upt' },
      },
      {
        icon: 'mdi-file-clock-outline',
        title: 'Laporan Pelaksanaan IHT',
        subtitle: 'Sekolah Penggerak',
        desc: 'Laporan Berkala dan Laporan Pelaksanaan',
        color: 'indigo',
        deepColor: 'darken-2',
        akses: 'psp-monev-laporan.index',
        link: 'diklat-iht',
        to: { name: 'diklat-iht' },
      },
      {
        icon: 'mdi-file-edit',
        title: 'Laporan IHT Balai',
        subtitle: 'Laporan Pelaksanaan',
        desc: 'Rekap proses pelaksanaan pendampingan IHT',
        color: 'light-blue',
        deepColor: 'darken-1',
        akses: 'psp-monev-dinas-rekap.index',
        key: 'iht-balai',
        disable: false,
        to: { name: 'iht-balai' },
      },
      {
        icon: 'mdi-file-edit',
        title: 'Lihat Laporan IHT Balai',
        subtitle: 'Laporan Pelaksanaan',
        desc: 'Rekap proses pelaksanaan pendampingan IHT',
        color: 'light-blue',
        deepColor: 'darken-1',
        akses: 'psp-monev-dinas-rekap.index',
        key: 'lihat-iht-balai',
        disable: false,
        to: { name: 'iht-balai' },
      },
    ],
  },
  {
    key: 'diklat',
    program: 'Diklat <strong>PKP</strong>',
    subheading: 'Diklat PKP',
    submenu: false,
    menu: [
      {
        icon: 'mdi-account-group-outline',
        title: 'Kelola Peserta Diklat PKP Susulan',
        subtitle: 'dari KS angkatan 1 dan 2',
        desc: 'Pengelolaan Peserta PKP dari KS PSP angkatan 1 dan 2',
        color: 'blue',
        deepColor: 'darken-1',
        akses: 'psp-peserta-diklat-kasek-susulan.index',
        link: 'pkp-susulan',
        to: { name: 'pkp-susulan' },
      },
      {
        icon: 'mdi-book-open-page-variant',
        title: 'Kelola Ajuan Peserta PKP',
        subtitle: 'Pelatihan Komite Pembelajaran',
        desc: 'Pengelolaan Peserta Pelatihan Komite Pembelajaran',
        color: 'blue',
        deepColor: 'darken-1',
        akses: 'psp-peserta-diklat-guru.index',
        link: 'pkp-ajuan',
        to: { name: 'pkp-ajuan' },
      },
      {
        icon: 'mdi-book-open-page-variant',
        title: 'Kelola Peserta PKP PAUD',
        subtitle: 'Pelatihan Komite Pembelajaran',
        desc: 'Pengelolaan Peserta Pelatihan Komite Pembelajaran',
        color: 'orange',
        deepColor: 'darken-1',
        akses: 'psp-peserta-diklat-guru-paud.index',
        link: 'pkp-ajuan-paud',
        to: { name: 'pkp-ajuan-paud' },
      },
      {
        icon: 'mdi-account-group-outline',
        title: 'Kelola Peserta Diklat PKP',
        subtitle: 'Sekolah Penggerak',
        desc: 'Evaluasi dan Verifikasi Daftar Peserta Pelatihan Komite Pembelajaran Sekolah Penggerak',
        color: 'red',
        deepColor: 'darken-2',
        akses: 'psp-peserta-diklat-verval.index',
        link: 'pkpp-verval',
        to: { name: 'pkp-verval' },
      },
      {
        icon: 'mdi-account-group-outline',
        title: 'Verval Peserta PKP PAUD',
        subtitle: 'Pelatihan Komite Pembelajaran',
        desc: 'Evaluasi dan Verifikasi Daftar Peserta Pelatihan Komite Pembelajaran Sekolah Penggerak',
        color: 'brown',
        deepColor: 'darken-2',
        akses: 'psp-peserta-diklat-verval-paud.index',
        link: 'pkp-verval-paud',
        to: { name: 'pkp-verval-paud' },
      },
      {
        icon: 'mdi-account-group-outline',
        title: 'Daftar Peserta PKP',
        subtitle: 'Pelatihan Komite Pembelajaran',
        desc: 'Daftar Peserta Guru Mapel PKP',
        color: 'green',
        deepColor: 'darken-2',
        akses: 'psp-peserta-diklat-guru.index-balai',
        link: 'diklat-peserta',
        to: { name: 'diklat-peserta' },
      },
      {
        icon: 'mdi-school',
        title: 'Diklat Platform Merdeka Mengajar',
        subtitle: 'Sekolah Penggerak',
        desc: 'Pengelolaan Peserta Diklat Platform Merdeka Mengajar',
        color: 'orange',
        deepColor: 'darken-1',
        akses: 'psp-peserta-dpp.index',
        link: 'diklat-dpp',
        to: { name: 'diklat-dpp' },
      },
      {
        key: 'sertifikat',
        icon: 'mdi-certificate-outline',
        title: 'Sertifikat',
        desc: 'Daftar Sertifikat',
        color: 'success',
        deepColor: '',
        akses: false,
        link: 'sertifikat',
        to: { name: 'sertifikat' },
      },
      {
        key: 'bi',
        icon: 'mdi-chart-tree',
        title: 'Analitik Pelaporan Instrumen',
        desc: 'Tautan menuju laman Analitik Pelaporan Instrumen',
        color: 'pink',
        deepColor: '',
        akses: 'psp-bi.instrumen-sekolah',
        href: '#BI_URL#',
      },
    ],
  },
  {
    key: 'diklat-ikm',
    program: 'Diklat <strong>IKM</strong>',
    subheading: 'Diklat IKM',
    submenu: false,
    menu: [
      {
        icon: 'mdi-account-group-outline',
        title: 'Kelola Peserta Diklat IKM Pengawas',
        desc: 'Pengelolaan Peserta Diklat IKM dari Pengawas',
        color: 'green',
        deepColor: 'darken-1',
        akses: 'psp-peserta-diklat-ikm-pengawas.index',
        link: 'ikm-pengawas',
        to: { name: 'ikm-pengawas' },
      },
    ],
  },
  {
    key: 'kelola',
    program: 'Kelola Akun',
    subheading: 'Kelola Akun',
    submenu: false,
    menu: [
      {
        icon: 'mdi-account',
        title: 'Kelola Admin',
        desc: 'Pengelolaan data Akun Admin',
        color: 'red',
        deepColor: 'darken-4',
        akses: 'psp-admin.index',
        link: 'admin',
        to: { name: 'admin' },
      },
      {
        icon: 'mdi-account',
        title: 'Kelola Penugasan',
        subtitle: 'Instruktur',
        desc: 'Pengelolaan data penugasan instruktur',
        color: 'blue',
        deepColor: 'darken-4',
        akses: 'psp-instruktur-penugasan.index',
        link: 'penugasan-instruktur',
        to: { name: 'penugasan-instruktur' },
      },
      {
        icon: 'mdi-account-multiple',
        title: 'Daftar Pendamping Implementasi Pembelajaran',
        subtitle: 'Daftar PIP',
        desc: 'Pengelolaan daftar akun Pendamping Implementasi Pembelajaran (PIP) ',
        color: 'pink',
        deepColor: 'Index.vue',
        akses: 'psp-pip-profil.index',
        link: 'pip',
        to: { name: 'pip' },
      },
    ],
  },
  {
    key: 'fitur-lainnya',
    program: 'Modul Lainnya',
    subheading: 'Modul Lainnya',
    submenu: false,
    menu: [
      {
        key: 'diklat',
        icon: 'mdi-google-classroom',
        title: 'Diklat PSP',
        desc: 'Tautan menuju Laman Diklat Program Sekolah Penggerak',
        color: 'primary',
        deepColor: '',
        akses: 'psp-elearning.diklat',
        href: '#LMS_URL#',
      },
      {
        icon: 'mdi-alert',
        title: 'Ajuan Data Tidak Sesuai',
        desc: 'Pengelolaan Ajuan Data Pendaftar yang Tidak Sesuai',
        color: 'orange',
        deepColor: 'darken-4',
        akses: 'psp-peserta-ajuan.index',
        link: 'peserta-ajuan',
        to: { name: 'peserta-ajuan' },
      },
    ],
  },
  {
    icon: 'mdi-web',
    title: 'Portal Sekolah Penggerak',
    desc: '',
    color: 'secondary',
    deepColor: 'darken-2',
    dividerTop: true,
    sidebar: true,
    akses: true,
    newtab: true,
    href: '#PORTAL_URL#',
  },
  {
    icon: 'mdi-webhook',
    title: 'ke Aplikasi SIMPKB',
    desc: '',
    color: 'secondary',
    deepColor: 'darken-2',
    sidebar: true,
    akses: true,
    link: 'app-sim-pkb',
    href: '#SIM_PKB_URL#',
  },
];
